module.exports = __webpack_public_path__ + "img/comunefe.9cfd5a99.jpg";